<template>
  <v-container fluid>
    <v-card>
      <v-toolbar>
        <v-icon>post_add</v-icon>
        <v-toolbar-title class="font-weight-light"
          >Manejo de Acuerdos de Pago</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)"
            >
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="3">
            <v-autocomplete
              v-model="filtro.empresaId"
              :items="empresas"
              autocomplete="disabled"
              item-text="nombre"
              item-value="id"
              label="De la Empresa"
              placeholder="Seleccione una"
            ></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              v-model="filtro.estadoId"
              :items="listEstadosAcuerdo"
              item-text="descripcion"
              item-value="id"
              label="Estado"
              placeholder="Seleccione uno"
            ></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <app-selector-periodos
              v-on:update-periodo="filtro.periodo = $event"
              :column="true"
            ></app-selector-periodos>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="3">
            <v-text-field
              v-model="filtro.cui"
              label="Buscar por documento/cuil"
            ></v-text-field>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="3">
            <v-btn color="success" @click="getItems(true)" :disabled="loading"
              >Traer Acuerdos</v-btn
            >
          </v-col>
        </v-row>

        <v-flex>
          <v-card>
            <v-toolbar dense :color="$store.state.UiColors.crudToolbarList">
              <v-icon>list</v-icon>
              <v-toolbar-title class="font-weight-light">Lista</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>

            <v-data-table
              dense
              :headers="headers"
              :items="records"
              :server-items-length="totalItems"
              :rows-per-page="pagination.rowsPerPage"
              :options.sync="pagination"
              v-model="selectedRows"
              :loading="loading"
              class="elevation-1"
              :footer-props="footer"
              item-key="id"
              show-select
            >
              <template v-slot:no-data>
                <v-alert
                  v-if="!primeraBusquedaRealizada"
                  :value="true"
                  color="grey lighten-3"
                  icon="info"
                >
                  Ingrese los filtros para realizar la búsqueda
                </v-alert>
                <v-alert v-else :value="true" color="grey" icon="warning">
                  No se encontraron datos
                </v-alert>
              </template>

              <template v-slot:header.data-table-select="{ on, props }">
                <v-checkbox
                  @change="selectAllChanged"
                  color="purple"
                  v-bind="props"
                  v-on="on"
                ></v-checkbox>
              </template>

              <template v-slot:item="{ item, isSelected, select }">
                <tr>
                  <td>
                    <v-simple-checkbox
                      class="caption"
                      color="green"
                      :value="isSelected"
                      @input="select($event)"
                    ></v-simple-checkbox>
                  </td>
                  <td>
                    <app-acciones-comunes
                      :documento="item.cuil.toString().substring(2, 10)"
                      :personaId="item.solicitanteId"
                    >
                    </app-acciones-comunes>
                  </td>

                  <td class="text-xs-left caption">{{ item.numero }}</td>
                  <td class="text-xs-left caption">
                    {{
                      item.fechaIngreso
                        | dateParse('YYYY-MM-DD')
                        | dateFormat('DD-MM-YYYY')
                    }}
                  </td>
                  <td class="text-xs-left caption">{{ item.estado }}</td>
                  <td class="text-xs-left caption">{{ item.solicitante }}</td>
                  <td class="text-xs-left caption">{{ item.cuil }}</td>

                  <td v-if="item.fechaAprobacion" class="text-xs-left caption">
                    {{
                      item.fechaAprobacion
                        | dateParse('YYYY-MM-DD')
                        | dateFormat('DD-MM-YYYY')
                    }}
                  </td>
                  <td class="text-xs-left caption"></td>

                  <td v-if="item.fechaCancela" class="text-xs-left caption">
                    {{
                      item.fechaCancela
                        | dateParse('YYYY-MM-DD')
                        | dateFormat('DD-MM-YYYY')
                    }}
                  </td>
                  <td class="text-xs-left caption"></td>

                  <td v-if="item.fechaBaja" class="text-xs-left caption">
                    {{
                      item.fechaBaja
                        | dateParse('YYYY-MM-DD')
                        | dateFormat('DD-MM-YYYY')
                    }}
                  </td>
                  <td v-else class="text-xs-left caption"></td>

                  <td class="text-xs-left caption">
                    <v-chip small :color="item.empresaColor" label dark>{{
                      item.empresaShort
                    }}</v-chip>
                  </td>
                  <td class="text-xs-left caption">
                    <v-btn
                      v-if="item.estado == 'Pendiente'"
                      color="pink"
                      x-small
                      dark
                      @click="
                        acuerdoSeleccionadoId = item.id;
                        showLegajoAnalisis = true;
                      "
                      >Analizar</v-btn
                    >
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
        <v-divider></v-divider>
      </v-card-text>
      <v-card-actions>
        <v-container fluid>
          <v-row dense>
            <v-col>
              <v-btn @click.stop="altaAcuerdo()" color="green" dark>
                Dar de Alta una Acuerdo</v-btn
              >
            </v-col>
            <v-col>
              <v-btn
                @click.stop="aprobarAcuerdo()"
                color="indigo"
                dark
                v-if="puedeAprobar"
              >
                Aprobar
                {{
                  selectedRows.length > 1 ? ' Masivo' : ' Acuerdo Seleccionado'
                }}</v-btn
              >
            </v-col>
            <v-col>
              <v-btn
                @click.stop="bajaAcuerdo()"
                color="brown"
                dark
                v-if="puedeDarDeBaja"
              >
                Dar de Baja
                {{
                  selectedRows.length > 1 ? ' Masivo' : ' Acuerdo Seleccionado'
                }}</v-btn
              >
            </v-col>
            <v-spacer></v-spacer>
            <v-col>
              <v-btn @click="imprimir" color="blue" dark>
                Imprimir Listado</v-btn
              >
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <v-row dense>
            <v-col cols="2">
              <v-switch
                label="Baja Masiva"
                v-model="filtro.bajaMasiva"
                color="indigo"
              ></v-switch>
            </v-col>
          </v-row>
          <v-row dense v-if="filtro.bajaMasiva">
            <v-col cols="3">
              <v-btn @click.stop="bajaAcuerdoMasivoExcel()" color="brown" dark>
                Dar de Baja Masivo Excel</v-btn
              >
            </v-col>
            <v-col cols="3">
              <v-file-input
                v-model="archivoFiltroOperaciones"
                placeholder="Seleccione el archivo Excel"
                label="Archivo Excel"
                prepend-icon="mdi-paperclip"
              >
              </v-file-input>
            </v-col>
          </v-row>

          <v-row align="center" v-if="filtro.bajaMasiva">
            <v-col cols="4" lg="3">
              <div>
                Registros que dieron error:
                <ul>
                  <li v-for="item in this.listBajaMasivaError" :key="item">
                    {{ item }}
                  </li>
                </ul>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>

    <!-- Analisis de Acuerdo  -->
    <v-dialog v-model="showLegajoAnalisis" width="1000">
      <v-card v-if="acuerdoSeleccionado">
        <!-- {{ acuerdoSeleccionado }} -->
        <v-card-title>Análisis de Acuerdo </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col><h3>Resumen del Acuerdo</h3></v-col>
          </v-row>
          <v-row dense>
            <v-col> Total a Reestructurar </v-col>
            <v-col>
              {{ acuerdoSeleccionado.importeTotal | currency }}
            </v-col>
          </v-row>
          <v-row dense>
            <v-col> Tope Cuota por el Cliente </v-col>
            <v-col> {{ acuerdoSeleccionado.importeCuota | currency }} </v-col>
          </v-row>
          <v-row dense>
            <v-col> Créditos que conforman el acuerdo </v-col>
            <v-col>{{ acuerdoSeleccionado.deudasIncluidas }} </v-col>
          </v-row>
          <v-row dense>
            <v-col> Medio de Cobro elegido </v-col>
            <v-col>
              {{
                acuerdoSeleccionado.tipoMedioCobroId == 1
                  ? 'Pago Voluntario'
                  : acuerdoSeleccionado.tipoMedioCobroId == 2
                  ? 'Débito en Cuenta'
                  : 'Tarjeta de Débito'
              }}
            </v-col>
          </v-row>
          <v-row dense>
            <v-col> Cantidad de Cuotas </v-col>
            <v-col> {{ acuerdoSeleccionado.cantidadCuotas }} </v-col>
          </v-row>
          <v-row dense>
            <v-col> Motivo Excepcion de Cuotas </v-col>
            <v-col> {{ acuerdoSeleccionado.motivoExcepcion }} </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-row dense>
            <v-col>
              <v-btn @click.stop="showAltaAcuerdo = true" color="pink" dark>
                Aprobar/Renegociar
              </v-btn>
            </v-col>
            <!-- <v-col>
              <v-btn @click.stop="aprobarAcuerdo()" color="indigo" dark>
                Aprobar
                {{
                  selectedRows.length > 1 ? ' Masivo' : ' Acuerdo Seleccionado'
                }}</v-btn
              >
            </v-col> -->
            <v-col>
              <v-btn @click.stop="bajaAcuerdo()" color="brown" dark>
                Dar de Baja
                {{
                  selectedRows.length > 1 ? ' Masivo' : ' Acuerdo Seleccionado'
                }}</v-btn
              >
            </v-col>
          </v-row></v-card-actions
        >
      </v-card>
    </v-dialog>

    <!-- Alta/Modificacion Acuerdo  -->
    <v-dialog v-model="showAltaAcuerdo" width="90%" v-if="acuerdoSeleccionado">
      <alta-acuerdo :acuerdoAModificar="acuerdoSeleccionado"> </alta-acuerdo>
    </v-dialog>

    <!-- Ver Legajo Cliente  -->
    <v-dialog v-model="showLegajoPersona" width="1000">
      <legajo-persona :personaId="selectedPersonaId"> </legajo-persona>
    </v-dialog>

    <!-- Ver Legajo Virtual  -->
    <v-dialog v-model="showLegajoVirtual" persistent width="700">
      <legajo-virtual
        :personaId="selectedPersonaId"
        @close-dialog="showLegajoVirtual = false"
      >
      </legajo-virtual>
    </v-dialog>

    <app-loading :loading="loading"></app-loading>

    <template v-if="$store.state.debugModeOn">
      Debug Info:
      <p></p>
      {{ selectedRows }}
      Model: {{ filtro }}
      <p></p>
    </template>
  </v-container>
</template>

<script>
import { http } from '@/axios';
import Vue from 'vue';

import AltaAcuerdo from '@/components/creditos/AltaAcuerdoV2.vue';

import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';

export default {
  components: {
    'alta-acuerdo': AltaAcuerdo,
  },
  data() {
    return {
      primeraBusquedaRealizada: false,
      loading: false,
      suspend: false,
      filterChanged: false,
      search: '', // valor para búsqueda
      pagination: {
        // definición de paginación
        sortDesc: [true],
        sortBy: [''],
        page: 1,
        itemsPerPage: 5,
      },
      footer: {
        showFirstLastPage: true,
        itemsPerPageOptions: [5, 10, 20, 50],
      },
      totalItems: 0, // va afuera de pagination
      headers: [
        // definición de columnas
        { text: 'Ver', value: 'accion', width: 80, sortable: false },
        { text: 'Numero', value: 'numero' },
        { text: 'Alta el', value: 'fechaAlta', width: 130 },
        { text: 'Estado', value: 'estado', width: 130 },
        { text: 'Se hizo a', value: 'solicitante' },
        { text: 'Cuil', value: 'cuil' },
        { text: 'Aprobado el', value: 'fechaAprobacion', width: 130 },
        { text: 'Cancelado el', value: 'fechaCancela', width: 130 },
        { text: 'Baja el', value: 'fechaBaja', width: 130 },
        { text: 'Empresa', value: 'empresaNombre' },
        { text: '', value: 'accion' },
      ],
      records: [], // registros
      selectedRows: [],
      listBajaMasiva: [],
      listBajaMasivaError: [],
      filtro: { empresaId: 0, estadoId: 0, cui: 0, periodo: { id: 1 } },
      empresas: [],
      sucursales: [],
      listEstadosAcuerdo: [],
      showDetalle: false,
      showLegajoPersona: false,
      showLegajoVirtual: false,
      selectedPersonaId: '',
      selectedTareaAsignadaId: '',
      selectedPersonaDocumento: '',
      selectedPersona: {},
      archivoFiltroOperaciones: [],
      showLegajoAnalisis: false,
      acuerdoSeleccionadoId: null,
      acuerdoSeleccionado: null,
      modificarCantidadCuotas: false,
      modificarCondonacion: false,
      modificarPrimerVencimiento: false,
      showAltaAcuerdo: false,
    };
  },
  async created() {
    this.loadEmpresas();
    this.loadEstadosAcuerdo();
  },
  watch: {
    acuerdoSeleccionadoId: {
      async handler() {
        if (this.acuerdoSeleccionadoId == null) return;
        // busco la info completa del acuerdo
        this.loading = true;
        try {
          var result = await http.get(
            'acuerdos?id=' + this.acuerdoSeleccionadoId
          );

          this.acuerdoSeleccionado = result;
          this.acuerdoSeleccionado.primerVencimiento = this.$moment(
            this.acuerdoSeleccionado.primerVencimiento
          ).format('YYYY-MM-DD');
          this.acuerdoSeleccionado.fechaAnticipo = this.$moment(
            this.acuerdoSeleccionado.fechaAnticipo
          ).format('YYYY-MM-DD');
        } catch (error) {
          // Error
          this.alertError(error);
        }
        this.loading = false;
      },
    },
    showLegajoAnalisis: {
      handler() {
        if (!this.showLegajoAnalisis) {
          this.acuerdoSeleccionadoId = null;
          this.acuerdoSeleccionado = null;
        }
      },
    },
    pagination: {
      handler() {
        if (this.primeraBusquedaRealizada) this.getItems(false);
      },
      deep: true,
    },
    search() {
      this.getItems(true);
    },
    activeTask: function() {
      //closeRelatedTasks es una variable del state que la pongo en true cuando se cierra el coso de activeTask y quiero cerrar otras cosas relacionadas
      if (this.closeRelatedTasks) {
        this.showDetalle = false;
        this.getItems(false);
      }
    },
  },
  computed: {
    ...mapGetters([
      'activeTask',
      'getActionFromLink',
      'user',
      'closeRelatedTasks',
    ]),
    action: function() {
      return this.getActionFromLink(this.$route.path);
    },
    puedeAprobar: function() {
      var hay = this.selectedRows.find((r) => r.estado != 'Pendiente');

      return this.selectedRows.length > 0 && !hay; // que no haya registros con estado que no sea Pendiente
    },
    puedeDarDeBaja: function() {
      var hay = this.selectedRows.find((r) => r.estado == 'Anulado');

      return this.selectedRows.length > 0 && !hay; // que no haya registros con estado que sea Anulado
    },
  },
  methods: {
    ...mapMutations([
      'setActiveTask',
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
      'setReporteActivo',
    ]),
    ...mapActions(['setStatusTareaFrecuente']),
    async getItems(resetPagination) {
      //Hago esto para que si cambias los filtros y tocas consultar traiga los resultados de la primera página
      if (resetPagination) {
        this.pagination.page = 1;
      }

      this.loading = true;
      this.$validator.reset();

      let filter = this.filtro;

      filter.cui = filter.cui ? filter.cui : 0;

      try {
        var result = await http.get(
          'acuerdos/list?empresaId=' +
            filter.empresaId +
            '&estadoId=' +
            filter.estadoId +
            '&fechaDesde=' +
            filter.periodo.desde +
            '&fechaHasta=' +
            filter.periodo.hasta +
            '&documento=' +
            filter.cui +
            '&limit=' +
            this.pagination.itemsPerPage +
            '&page=' +
            this.pagination.page +
            '&sortby=' +
            this.pagination.sortBy +
            '&descending=' +
            (this.pagination.sortDesc.length > 0
              ? this.pagination.sortDesc
              : 'false')
        );

        Vue.$log.debug(result);

        this.records = result.list;

        this.totalItems = result.totalCount;
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.primeraBusquedaRealizada = true;
      this.loading = false;
    },
    selectAllChanged(toggle) {
      this.selectedRows = [];
      if (toggle) {
        for (let index = 0; index < this.records.length; index++) {
          const element = this.records[index];

          this.selectedRows.push(element);
        }
      }
    },
    async loadEmpresas() {
      this.loading = true;
      try {
        var result = await http.get(
          'empresas/list/porusuario?usuarioId=' + this.user.id
        );

        this.empresas = result.list;
        this.empresas.unshift({ id: 0, nombre: '(Todas)' });
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async loadEstadosAcuerdo() {
      this.listEstadosAcuerdo.push({ id: 0, descripcion: '(Todos)' });
      this.listEstadosAcuerdo.push({ id: 1, descripcion: 'Pendiente' });
      this.listEstadosAcuerdo.push({ id: 2, descripcion: 'Activo' });
      this.listEstadosAcuerdo.push({ id: 3, descripcion: 'Cancelado' });
      this.listEstadosAcuerdo.push({ id: 4, descripcion: 'Anulado' });
    },
    altaAcuerdo() {
      var params = {
        width: 900,
        visible: true,
      };

      this.setActiveTask({ task: 'app-alta-acuerdo', props: params });
    },
    async aprobarAcuerdo() {
      if (this.selectedRows.length > 1) {
        const res = await this.$dialog.confirm({
          text:
            '¿Confirma la Aprobación de los ' +
            this.selectedRows.length +
            ' acuerdos seleccionados?',
          title: 'Operación Masiva',
          persistent: true, // Parece que no funciona...
        });
        if (!res) return;
      }

      for (let index = 0; index < this.selectedRows.length; index++) {
        const acuerdo = this.selectedRows[index];

        this.loading = true;

        try {
          var params = {};
          params.acuerdoId = acuerdo.id;
          params.estadoId = 2; // aprobado
          params.motivo = '';

          await http.post(
            'acuerdos/cambiarestado',
            JSON.stringify({ parametros: params })
          );
        } catch (error) {
          // Error
          Vue.$log.error(error);
          this.alertError(error);
        }
      }

      this.selectedRows = []; // limpio la selección
      this.getItems(false); // refresco
    },

    async imprimir() {
      let filter = this.filtro;

      let params = [];
      params.push({
        EmpresaId: filter.empresaId, // CanalesVenta
        EstadoId: filter.estadoId, // SucursalId
        IngresoDesde: filter.periodo.desde, // IngresoDesde
        IngresoHasta: filter.periodo.hasta, // IngresoHasta
        Documento: filter.cui, // Documento
      });

      this.setReporteActivo({ reporte: 'Acuerdos.trdp', params: params });

      window.open('/report-viewer');
    },
    async bajaAcuerdo() {
      if (this.selectedRows.length > 1) {
        const res = await this.$dialog.confirm({
          text:
            '¿Confirma la Baja de los ' +
            this.selectedRows.length +
            ' acuerdos seleccionados?',
          title: 'Operación Masiva',
          persistent: true, // Parece que no funciona...
        });
        if (!res) return;
      }

      for (let index = 0; index < this.selectedRows.length; index++) {
        const acuerdo = this.selectedRows[index];

        this.loading = true;

        try {
          var params = {};
          params.acuerdoId = acuerdo.id;
          params.estadoId = 4; // baja
          params.motivo = '';

          await http.post(
            'acuerdos/cambiarestado',
            JSON.stringify({ parametros: params })
          );
        } catch (error) {
          // Error
          Vue.$log.error(error);
          this.alertError(error);
        }
      }

      this.selectedRows = []; // limpio la selección
      this.getItems(false); // refresco
    },
    async bajaAcuerdoMasivoExcel() {
      if (!this.archivoFiltroOperaciones) return;

      if (!this.archivoFiltroOperaciones.name.includes('.xls')) {
        this.archivoFiltroOperaciones = [];
        this.alertWarning('Debe elegir un archivo Excel.');
        return;
      }

      this.loading = true;
      let request = new FormData();

      request.append('archivo', this.archivoFiltroOperaciones);

      var result = await http.post(
        'acuerdos/cambiarestadomasivoexcel',
        request
      );

      this.listBajaMasiva = result;

      console.log(this.listBajaMasiva);
      console.log(this.listBajaMasiva.length);

      for (let i = 0; i < this.listBajaMasiva.length; i++) {
        try {
          var params = {};
          params.acuerdoId = this.listBajaMasiva[i];
          params.estadoId = 4; // baja
          params.motivo = 'Baja Masiva';

          await http.post(
            'acuerdos/cambiarestado',
            JSON.stringify({ parametros: params })
          );
        } catch (error) {
          //Error
          var mensajeError = 'Registro ' + (i + 1) + ' | ' + error;
          console.log('Error Mesagge: ' + mensajeError);
          this.listBajaMasivaError.push(mensajeError);
        }
      }

      this.loading = false;

      this.alertSuccess(
        'Se dieron de baja ' +
          (this.listBajaMasiva.length - this.listBajaMasivaError.length) +
          ' acuerdos'
      );
    },
  },
};
</script>
